import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Box, Columns, Column, Stack, Text, Loader, Alert, Inline, Badge, Divider, Heading } from "braid-design-system";
import { useContractBalancesForHirerBalanceQuery, useHirerAccountForHirerBalanceQuery, useOrderSummaryPresentationData, assert, OrderSummaryLayout, alertMessageResponses, OrderSummaryDataContext, CPQASummary, LoggerProvider, OrderSummaryDataProvider } from "./styles/HirerOrderSummary/components/CPQASummary/CPQASummary.mjs";
import { TrackingProvider, HirerBalancePresentation } from "./styles/HirerContractBalance/HirerBalancePresentation.mjs";
import { useTranslations } from "@vocab/react";
import { translations } from "./HirerContractBalance/components/ErrorAlert/.vocab/index.mjs";
import { createContext, useContext, useEffect, useState } from "react";
import { translations as translations$1 } from "./HirerOrderSummary/components/.vocab/index.mjs";
import { formatMinorUnits } from "@seek/currency";
import { format, parseISO } from "date-fns";
import { OrderTableRow, SubTotal } from "./styles/HirerOrderSummary/components/SubTotal/SubTotal.mjs";
import { TaxSuffix } from "@seek/tax-suffix";
const ErrorImage = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    children: [
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
        "path",
        {
          id: "ylz1yo9wva",
          d: "M0.026 0.57L82.526 0.57 82.526 79.927 0.026 79.927z"
        }
      ) }),
      /* @__PURE__ */ jsx("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0 0H120V120H0z",
            transform: "translate(-776 -885) translate(0 824) translate(736) translate(40 61)"
          }
        ) }),
        /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsxs("g", { transform: "translate(-776 -885) translate(0 824) translate(736) translate(40 61) translate(5 13) translate(0 .216)", children: [
            /* @__PURE__ */ jsx("mask", { id: "sec8z48c8b", fill: "#fff", children: /* @__PURE__ */ jsx("use", { href: "#ylz1yo9wva" }) }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: "#FFD1DD",
                d: "M71.526.57h-60.5c-6.05 0-11 4.95-11 11v57.357c0 6.05 4.95 11 11 11h29.447l-.069-7.021h5.346c3.777 0 6.851-3.073 6.851-6.851s-3.074-6.852-6.851-6.852H40.41V39.461h16.901v-3.765c0-4.645 3.779-8.423 8.423-8.423s8.423 3.778 8.423 8.423v3.766l8.368-.007V11.57c0-6.05-4.95-11-11-11",
                mask: "url(#sec8z48c8b)"
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#031D44",
              fillRule: "nonzero",
              d: "M94.46 41.348c.541.106.894.632.787 1.174-.106.542-.632.895-1.174.788-1.36-.267-2.748-.037-3.959.658-.479.276-1.09.11-1.365-.368-.276-.48-.11-1.09.368-1.366 1.63-.936 3.508-1.247 5.342-.886zm6.256 7.77c-.014.551-.472.988-1.024.975-.552-.013-.989-.472-.976-1.024.025-1.04-.236-2.066-.765-2.985-.151-.263-.32-.512-.508-.745-.346-.43-.277-1.06.154-1.406.43-.345 1.06-.276 1.406.154.252.314.48.648.682 1 .71 1.236 1.064 2.622 1.03 4.03zm-.102 6.467c.534.143.85.692.706 1.225-.144.534-.693.85-1.226.706l-3.252-.876.873-3.232c.144-.533.693-.849 1.226-.705.533.144.849.693.705 1.227l-.612 2.265-.706-1.226 2.286.616zm9.104 2.452c.534.144.85.693.706 1.226-.144.533-.692.849-1.226.705l-4.552-1.226c-.533-.144-.849-.692-.705-1.226.143-.533.692-.849 1.225-.705l4.552 1.226zm-1.633 10.253c-.145.533-.694.848-1.227.703-.533-.144-.848-.694-.704-1.227l1.235-4.55c.144-.533.693-.847 1.226-.703.533.145.848.694.704 1.227l-1.234 4.55zm-2.469 9.1c-.144.533-.694.848-1.227.703-.533-.145-.848-.694-.703-1.227l1.234-4.55c.145-.533.694-.848 1.227-.703.533.144.848.694.703 1.227l-1.234 4.55zm-2.53 9.164c-.187.52-.76.79-1.28.603-.52-.187-.79-.76-.603-1.28.106-.295.2-.596.284-.903l.965-3.558c.144-.533.694-.848 1.227-.703.533.144.848.694.703 1.227l-.965 3.556c-.096.358-.207.711-.331 1.058zm-6.648 7.5c-.493.249-1.094.05-1.343-.443-.248-.493-.05-1.094.444-1.343 1.303-.656 2.472-1.553 3.441-2.643.367-.412.999-.45 1.412-.082.412.367.45.999.083 1.411-1.138 1.279-2.509 2.331-4.037 3.1zm-9.925.891c-.534-.144-.85-.693-.705-1.226.143-.533.692-.849 1.226-.705l.357.097c1.328.353 2.683.466 4.021.342.55-.05 1.037.355 1.088.905.05.55-.354 1.036-.904 1.087-1.572.145-3.164.012-4.722-.403l-.361-.097zm-9.103-2.457c-.533-.144-.849-.693-.705-1.226.144-.534.693-.85 1.226-.705l4.551 1.228c.534.144.85.693.705 1.227-.144.533-.693.848-1.226.704l-4.551-1.228zm-9.103-2.458c-.533-.144-.849-.693-.705-1.226.144-.533.693-.849 1.226-.705l4.552 1.229c.533.144.848.693.704 1.226-.143.533-.692.849-1.226.705l-4.55-1.229zm-9.103-2.457c-.533-.144-.848-.693-.704-1.226.144-.533.692-.849 1.226-.705l4.551 1.229c.533.144.849.693.705 1.226-.144.533-.693.848-1.226.705l-4.552-1.23zm2.445-8.902c.534.144.85.693.705 1.226-.144.533-.693.848-1.226.705l-1.096-.296 1.227-.71-.917 3.46c-.141.534-.688.852-1.222.71-.534-.141-.852-.688-.71-1.222l1.174-4.431 2.065.558zm9.71.122c.29.47.144 1.087-.326 1.376l-.26.155c-1.47.845-3.112 1.279-4.785 1.267-.552-.004-.996-.454-.993-1.007.004-.552.455-.997 1.007-.993 1.318.01 2.612-.332 3.775-1l.206-.124c.47-.29 1.086-.144 1.376.326zm2.146-7.446c-.054-.55.347-1.04.897-1.094.55-.054 1.039.347 1.093.897.113 1.14.017 2.294-.286 3.417-.158.584-.368 1.147-.629 1.685-.24.497-.84.704-1.336.463-.497-.241-.704-.84-.463-1.336.206-.425.372-.871.497-1.333.24-.89.316-1.801.227-2.699zm-4.88-6.294c-.52-.19-.786-.764-.597-1.283.19-.518.763-.785 1.282-.596 1.693.617 3.159 1.692 4.253 3.117.336.438.254 1.066-.184 1.402-.438.336-1.066.254-1.402-.184-.863-1.123-2.016-1.969-3.353-2.456zm-3.56-7.204c.146-.533.695-.847 1.228-.702.533.145.847.695.702 1.228l-1.238 4.548c-.145.533-.695.848-1.228.702-.533-.145-.847-.694-.702-1.227l1.238-4.549zm2.477-9.097c.145-.533.695-.848 1.228-.702.533.145.847.694.702 1.227l-1.238 4.549c-.145.533-.695.847-1.228.702-.533-.145-.847-.695-.702-1.228l1.238-4.548zm9.604.495c.534.144.849.693.705 1.226-.144.534-.693.849-1.226.705l-4.551-1.23c-.534-.144-.849-.693-.705-1.227.144-.533.693-.848 1.227-.704l4.55 1.23zm7.195 1.98c.144-.533.693-.848 1.226-.705.533.144.849.693.705 1.227l-.513 1.898-4.583-1.239c-.534-.144-.849-.693-.705-1.226.144-.533.693-.849 1.226-.705l3.619.978-.261.966-.966-.26.252-.934zm4.563-8.865c.47-.29 1.086-.145 1.376.325.29.47.144 1.086-.326 1.377-1.184.73-2.047 1.843-2.46 3.17-.163.528-.724.823-1.251.659-.528-.164-.822-.725-.658-1.252.556-1.789 1.724-3.295 3.319-4.28zM41.245 1.158c.513.005.932.395.985.893l.006.117-.08 8.269c-.004.51-.39.927-.884.984l-.115.006h-4.553c-3.666 0-6.637 2.971-6.637 6.637 0 3.587 2.847 6.51 6.404 6.633l.233.004h4.553c.512 0 .935.386.993.883l.007.117v14.761c0 .513-.387.936-.885.993l-.116.007-8.653-.007v3.552c0 4.683-3.727 8.495-8.378 8.632l-.259.004c-4.683 0-8.495-3.727-8.632-8.377l-.004-.26-.001-3.552H1.239c-.513 0-.936-.386-.993-.883l-.007-.117c0-.513.386-.935.883-.993l.117-.007h14.99c.514 0 .936.386.994.884l.007.116v4.553c0 3.665 2.97 6.636 6.636 6.636 3.588 0 6.51-2.846 6.633-6.403l.004-.233v-4.553c0-.513.387-.936.884-.993l.117-.007 8.652.007V26.7h-3.552c-4.683 0-8.496-3.727-8.633-8.377l-.004-.26c0-4.682 3.728-8.495 8.378-8.632l.26-.004h3.56l.07-7.278c.006-.513.396-.932.894-.985l.116-.006z",
              transform: "translate(-776 -885) translate(0 824) translate(736) translate(40 61) translate(5 13)"
            }
          )
        ] })
      ] }) }) }) }) })
    ]
  }
);
const ErrorAlert = () => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(Box, { padding: "large", background: "surface", children: /* @__PURE__ */ jsxs(Columns, { space: "large", alignY: "center", collapseBelow: "tablet", children: [
    /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Box, { textAlign: "center", children: /* @__PURE__ */ jsx(ErrorImage, {}) }) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(Text, { size: "large", weight: "strong", children: t("Oops!") }),
      /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
        /* @__PURE__ */ jsx(Text, { children: t(
          "A technical error has occurred and we are unable to show your SEEK contract information."
        ) }),
        /* @__PURE__ */ jsx(Text, { children: t("Please refresh the page and try again.") })
      ] })
    ] }) })
  ] }) });
};
const mapGraphqlToContractBalanceProp = (contractBalance) => {
  const currentContract = (contractBalance.contracts || [])[0];
  return {
    ...contractBalance,
    expiresSoon: currentContract == null ? void 0 : currentContract.expiry.expiresSoon
  };
};
const getPricingModel = (pricingModelFromHirerAccount, hirerAccountError) => {
  if (hirerAccountError || !pricingModelFromHirerAccount) {
    return "HORIZON";
  }
  return pricingModelFromHirerAccount;
};
const HirerContractBalance = ({
  locale,
  advertiserNation,
  tracking = () => {
  },
  ...otherProps
}) => {
  var _a;
  const {
    loading: contractBalanceLoading,
    error: contractBalanceError,
    data: contractBalanceData
  } = useContractBalancesForHirerBalanceQuery({
    variables: { advertiserNation }
  });
  const {
    loading: hirerAccountLoading,
    error: hirerAccountError,
    data: hirerAccountData
  } = useHirerAccountForHirerBalanceQuery();
  if (contractBalanceLoading || hirerAccountLoading) {
    return /* @__PURE__ */ jsx(Box, { "data-testid": "Loader", children: /* @__PURE__ */ jsx(Loader, { size: "xsmall" }) });
  }
  if (contractBalanceError) {
    return /* @__PURE__ */ jsx(ErrorAlert, {});
  }
  const pricingModel = getPricingModel(
    (_a = hirerAccountData == null ? void 0 : hirerAccountData.hirerAccount) == null ? void 0 : _a.pricingModel,
    hirerAccountError
  );
  const contractBalances = ((contractBalanceData == null ? void 0 : contractBalanceData.contractBalances) ?? []).map(
    (x) => mapGraphqlToContractBalanceProp(x)
  );
  return /* @__PURE__ */ jsx(TrackingProvider, { context: tracking, children: /* @__PURE__ */ jsx(
    HirerBalancePresentation,
    {
      ...otherProps,
      contractBalances,
      pricingModel,
      locale
    }
  ) });
};
var Locales = /* @__PURE__ */ ((Locales2) => {
  Locales2["AU"] = "AU";
  Locales2["NZ"] = "NZ";
  return Locales2;
})(Locales || {});
const AlertMessage = ({ message }) => /* @__PURE__ */ jsx(Alert, { tone: "info", children: /* @__PURE__ */ jsx(Text, { children: message }) });
const ProductLineItemContext = createContext(void 0);
const LineItemCost = ({ lineItem, showMinus, language }) => {
  const tone = useContext(ProductLineItemContext);
  if (lineItem.state === "fullPrice" && lineItem.netPrice !== lineItem.retailPrice) {
    return /* @__PURE__ */ jsxs(Inline, { space: "small", align: "right", children: [
      /* @__PURE__ */ jsx(Text, { tone, children: /* @__PURE__ */ jsx("s", { children: formatMinorUnits(lineItem.retailPrice, {
        currency: lineItem.currency,
        locale: language
      }) }) }),
      /* @__PURE__ */ jsxs(Text, { tone, children: [
        showMinus ? `–` : "",
        " ",
        formatMinorUnits(lineItem.netPrice, {
          currency: lineItem.currency,
          locale: language
        })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs(Text, { tone, align: "right", children: [
    showMinus ? `– ` : "",
    formatMinorUnits(
      lineItem.state === "fullPrice" ? lineItem.netPrice : lineItem.outstandingAmount,
      {
        currency: lineItem.currency,
        locale: language
      }
    )
  ] });
};
const ProductLineItem = ({ lineItem, showMinus, showPartial, tone, language }) => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(ProductLineItemContext.Provider, { value: tone, children: /* @__PURE__ */ jsx(
    OrderTableRow,
    {
      left: /* @__PURE__ */ jsxs(Inline, { space: "small", alignY: "center", children: [
        /* @__PURE__ */ jsx(Text, { tone, children: lineItem.title }),
        lineItem.state === "outstanding" && showPartial && /* @__PURE__ */ jsx(Badge, { tone: "neutral", children: t("partial payment...") })
      ] }),
      right: /* @__PURE__ */ jsx(
        LineItemCost,
        {
          lineItem,
          showMinus,
          language
        }
      )
    }
  ) });
};
const HeaderText = ({
  content,
  expiryDate
}) => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(Inline, { space: "xsmall", alignY: "center", children: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Text, { weight: "medium", children: content }),
    expiryDate && /* @__PURE__ */ jsx(Badge, { tone: "neutral", children: t("expires...", {
      date: format(parseISO(expiryDate), "dd/MM/yyyy")
    }) })
  ] }) });
};
const LeftAlignedText = (props) => /* @__PURE__ */ jsx(Text, { ...props, align: "left" });
const RightAlignedText = (props) => /* @__PURE__ */ jsx(Text, { ...props, align: "right" });
const ContractBalanceItem = ({ item }) => {
  const { orderSummary, language } = useOrderSummaryPresentationData();
  const { t } = useTranslations(translations$1);
  const isUsingStackedContract = orderSummary.contractBalanceItems.length >= 2;
  const isPayable = orderSummary.subTotal > 0;
  const showOutstanding = item.outstandingBalance > 0 && item.remainingBalance === 0;
  return /* @__PURE__ */ jsx(Stack, { space: "large", children: /* @__PURE__ */ jsxs(Fragment, { children: [
    item.alertMessage && /* @__PURE__ */ jsx(AlertMessage, { message: t(item.alertMessage) }),
    /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
      /* @__PURE__ */ jsx(
        OrderTableRow,
        {
          left: /* @__PURE__ */ jsx(
            HeaderText,
            {
              content: item.contractName,
              expiryDate: isUsingStackedContract ? void 0 : item.expiryDate
            }
          ),
          right: /* @__PURE__ */ jsx(RightAlignedText, { weight: "medium", children: t("balance...") })
        }
      ),
      /* @__PURE__ */ jsx(Divider, { weight: "strong" })
    ] }),
    /* @__PURE__ */ jsx(
      OrderTableRow,
      {
        left: /* @__PURE__ */ jsx(LeftAlignedText, { children: t("starting balance...") }),
        right: /* @__PURE__ */ jsx(RightAlignedText, { children: formatMinorUnits(item.startingBalance, {
          currency: item.currency,
          locale: language
        }) })
      }
    ),
    item.lineItems.map((lineItem, index) => /* @__PURE__ */ jsx(
      ProductLineItem,
      {
        lineItem,
        showMinus: true,
        tone: "secondary",
        language
      },
      `lineitem-${index}`
    )),
    showOutstanding ? /* @__PURE__ */ jsx(
      OrderTableRow,
      {
        left: /* @__PURE__ */ jsx(LeftAlignedText, { children: t("outstanding balance...") }),
        right: /* @__PURE__ */ jsxs(RightAlignedText, { tone: "critical", children: [
          "–",
          " ",
          formatMinorUnits(item.outstandingBalance, {
            currency: item.currency,
            locale: language
          })
        ] })
      }
    ) : /* @__PURE__ */ jsx(
      OrderTableRow,
      {
        left: /* @__PURE__ */ jsx(LeftAlignedText, { weight: isPayable ? "regular" : "medium", children: t("remaining balance...") }),
        right: /* @__PURE__ */ jsx(RightAlignedText, { weight: isPayable ? "regular" : "medium", children: formatMinorUnits(item.remainingBalance, {
          currency: item.currency,
          locale: language
        }) })
      }
    )
  ] }) });
};
const ContractBalance = () => {
  const {
    orderSummary: { contractBalanceItems },
    padding
  } = useOrderSummaryPresentationData();
  const { t } = useTranslations(translations$1);
  assert(
    (contractBalanceItems == null ? void 0 : contractBalanceItems.length) > 0,
    "contractBalanceItems shouldn't be undefined or empty"
  );
  return /* @__PURE__ */ jsx(OrderSummaryLayout, { paddingStyles: padding, title: t("your ad budget..."), children: /* @__PURE__ */ jsx(Stack, { space: "large", children: /* @__PURE__ */ jsx(Stack, { space: "large", dividers: true, children: contractBalanceItems.map((balanceItem, index) => /* @__PURE__ */ jsx(ContractBalanceItem, { item: balanceItem }, index)) }) }) });
};
const PayableHeader = () => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(
    OrderTableRow,
    {
      left: /* @__PURE__ */ jsx(Heading, { level: "4", children: t("items...") }),
      right: /* @__PURE__ */ jsx(Heading, { level: "4", align: "right", children: t("cost...") })
    }
  );
};
const Total = ({ total, tax, language, currency }) => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(
    OrderTableRow,
    {
      left: tax ? /* @__PURE__ */ jsx(
        TaxSuffix,
        {
          taxCode: tax.code,
          displayRecommendation: "inclusive",
          locale: language,
          children: /* @__PURE__ */ jsx(Heading, { level: "3", children: t("total...") })
        }
      ) : /* @__PURE__ */ jsx(Heading, { level: "3", children: t("total...") }),
      right: /* @__PURE__ */ jsx(Heading, { level: "3", align: "right", children: formatMinorUnits(total, { currency, locale: language }) })
    }
  );
};
const PayablesSummary = () => {
  var _a;
  const {
    orderSummary: {
      payableLineItems,
      subTotal,
      surcharge,
      tax,
      total,
      currency
    },
    padding,
    language
  } = useOrderSummaryPresentationData();
  const { t } = useTranslations(translations$1);
  assert(
    payableLineItems.length > 0,
    "show payable summary only when there is payable line item"
  );
  const payingProductLineItem = payableLineItems.find(
    (lineItem) => lineItem.state === "outstanding"
  );
  const isAmountAboveZero = subTotal > 0 || ((_a = tax == null ? void 0 : tax.amount) == null ? void 0 : _a.value) && tax.amount.value > 0 || surcharge > 0;
  return /* @__PURE__ */ jsx(OrderSummaryLayout, { paddingStyles: padding, title: t("order summary..."), children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    payingProductLineItem && /* @__PURE__ */ jsx(AlertMessage, { message: t(alertMessageResponses.costThisInvoice) }),
    /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
      /* @__PURE__ */ jsx(PayableHeader, {}),
      /* @__PURE__ */ jsx(Divider, { weight: "strong" })
    ] }),
    payableLineItems.map((item) => /* @__PURE__ */ jsx(
      ProductLineItem,
      {
        lineItem: item,
        language,
        showPartial: true
      },
      item.title
    )),
    isAmountAboveZero && /* @__PURE__ */ jsx(
      SubTotal,
      {
        subTotal,
        tax,
        surcharge,
        language,
        currency
      }
    ),
    /* @__PURE__ */ jsx(
      Total,
      {
        total,
        tax,
        language,
        currency
      }
    )
  ] }) });
};
const OrderSummary = () => {
  const {
    orderSummary: { contractBalanceItems, total },
    space = "large"
  } = useOrderSummaryPresentationData();
  const { hubbleTrackEventHandler, orderSummary: contextOrderSummary } = useContext(OrderSummaryDataContext);
  const orderId = contextOrderSummary == null ? void 0 : contextOrderSummary.orderId;
  const showContractBalanceItems = (contractBalanceItems == null ? void 0 : contractBalanceItems.length) > 0;
  const showPayablesSummary = total > 0;
  useEffect(() => {
    if (orderId && (showContractBalanceItems || showPayablesSummary)) {
      hubbleTrackEventHandler("order_summary_displayed", {
        orderId
      });
    }
  }, [
    orderId,
    hubbleTrackEventHandler,
    showContractBalanceItems,
    showPayablesSummary
  ]);
  return /* @__PURE__ */ jsxs(Stack, { space, children: [
    showContractBalanceItems && /* @__PURE__ */ jsx(ContractBalance, {}),
    showPayablesSummary && /* @__PURE__ */ jsx(PayablesSummary, {})
  ] });
};
const OrderSummaryPresentation = () => {
  const { cpqaOrderSummary } = useOrderSummaryPresentationData();
  return cpqaOrderSummary ? /* @__PURE__ */ jsx(CPQASummary, {}) : /* @__PURE__ */ jsx(OrderSummary, {});
};
const HirerOrderSummary = (props) => /* @__PURE__ */ jsx(LoggerProvider, { context: props.logger || {}, children: /* @__PURE__ */ jsx(OrderSummaryDataProvider, { ...props, children: /* @__PURE__ */ jsx(OrderSummaryPresentation, {}) }) });
const CartContext = createContext(null);
const CartProvider = ({
  cart,
  children
}) => {
  const [lineItems, setLineItems] = useState([]);
  const [promoCode, setPromoCode] = useState(void 0);
  const updateProductSetId = (productSetId) => {
    console.log(`updateProductSetId: ${productSetId}`);
  };
  const addLineItem = (newLineItem) => {
    console.log(`addLineItem: ${JSON.stringify(newLineItem)}`);
    setLineItems([...lineItems, newLineItem]);
  };
  const removeLineItem = ({ id, reference }) => {
    console.log(`removeLineItem id: ${id}, reference: ${reference}`);
  };
  const clearCart = () => {
  };
  const applyPromoCode = (code) => {
    console.log(`applyPromoCode: ${code}`);
    setPromoCode(code);
  };
  console.log(`PromoCode: ${promoCode}`);
  const clearPromoCode = () => {
    setPromoCode(void 0);
  };
  const updateLineItem = (target, update) => {
    console.log(
      `updateLineItem target: ${JSON.stringify(
        target
      )}, update: ${JSON.stringify(update)}`
    );
  };
  return /* @__PURE__ */ jsx(
    CartContext.Provider,
    {
      value: {
        cart,
        updateProductSetId,
        addLineItem,
        removeLineItem,
        clearCart,
        applyPromoCode,
        clearPromoCode,
        updateLineItem
      },
      children
    }
  );
};
const useCart = () => {
  const context = useContext(CartContext);
  if (context === null) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};
export {
  CartProvider,
  HirerContractBalance,
  HirerOrderSummary,
  Locales as Locale,
  useCart
};
